<template>
  <div class="download-page">
    <!-- Breadcrumb -->
    <div class="breadcrumb-bar">
      <div class="breadcrumb-inner">
        <router-link to="/">{{ $t('nav.home') }}</router-link>
        <span class="breadcrumb-separator">&gt;</span>
        <span class="breadcrumb-current">{{ $t('nav.download') }}</span>
      </div>
    </div>

    <div class="download-container">
      <!-- Main Content -->
      <div class="download-main">
        <h1 class="page-title">{{ $t('download_page.title') || $t('nav.download') }}</h1>

        <div class="download-list">
          <div class="download-item" v-for="(item, index) in downloadList" :key="index">
            <div class="download-icon">
              <img :src="item.icon" :alt="item.name">
            </div>
            <div class="download-info">
              <h3 class="download-name">{{ item.name }}</h3>
              <span class="download-platform">{{ item.platform }}</span>
            </div>
            <a class="download-btn" :href="item.link" target="_blank" rel="noopener">
              <span>{{ $t('download_page.download_btn') || 'Download' }}</span>
              <svg class="download-arrow" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 5v14M5 12l7 7 7-7"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Agreement -->
        <div class="download-agreement">
          <p>
            {{ $t('leecho.agreement.prefix') }}
            <a :href="userAgreementUrl" target="_blank" rel="noopener" class="agreement-link">{{ $t('leecho.agreement.user') }}</a>
            {{ $t('leecho.agreement.and') }}
            <a :href="privacyPolicyUrl" target="_blank" rel="noopener" class="agreement-link">{{ $t('leecho.agreement.privacy') }}</a>
          </p>
        </div>

        <!-- QR Code Section -->
        <div class="qr-section">
          <h2 class="qr-title">{{ $t('download') }}</h2>
          <div class="qr-content">
            <div class="qr-image-wrapper">
              <img src="/images/download.png" alt="QR Code" class="qr-image">
            </div>
            <p class="qr-desc">{{ $t('download_page.qr_desc') || $t('download') }}</p>
          </div>
        </div>
      </div>

      <!-- Sidebar -->
      <aside class="download-sidebar">
        <div class="sidebar-card">
          <h3 class="sidebar-title">{{ $t('download_page.quick_links') || 'Quick Links' }}</h3>
          <ul class="sidebar-links">
            <li v-for="(link, index) in quickLinks" :key="index">
              <router-link :to="link.path">{{ link.name }}</router-link>
            </li>
          </ul>
        </div>

        <div class="sidebar-card contact-card">
          <h3 class="sidebar-title">{{ $t('download_page.contact') || 'Contact Us' }}</h3>
          <div class="contact-info">
            <div class="contact-item">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#0066cc" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
              </svg>
              <span>4008 256 090</span>
            </div>
            <div class="contact-item">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#0066cc" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <span>445995614@qq.com</span>
            </div>
          </div>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      downloadList: [
        {
          name: 'Le-Echo',
          platform: 'Android',
          icon: require('@/assets/images/logo-1-zh.png'),
          link: '#'
        },
        {
          name: 'Le-Echo',
          platform: 'iOS',
          icon: require('@/assets/images/logo-1-zh.png'),
          link: '#'
        }
      ],
      quickLinks: []
    };
  },
  computed: {
    lang() {
      let srcLan = this.$i18n.locale;
      if (srcLan.indexOf('en') !== -1) {
        return 'en';
      }
      return 'zh';
    },
    privacyPolicyUrl() {
      return this.lang === 'en'
        ? 'https://le-echo.mltcloud.com/private/privacy_policy_en.html'
        : 'https://le-echo.mltcloud.com/private/privacy_policy.html';
    },
    userAgreementUrl() {
      return this.lang === 'en'
        ? 'https://le-echo.mltcloud.com/private/user_agreement_en.html'
        : 'https://le-echo.mltcloud.com/private/user_agreement.html';
    }
  },
  mounted() {
    document.body.className = "page-template-default page page-one-column colors-light";
    this.updateQuickLinks();
  },
  watch: {
    '$i18n.locale'() {
      this.updateQuickLinks();
    }
  },
  methods: {
    updateQuickLinks() {
      this.quickLinks = [
        { name: this.$t('nav.home'), path: '/' },
        { name: this.$t('nav.products'), path: '/products' },
        { name: this.$t('nav.leecho'), path: '/leecho' },
        { name: this.$t('nav.contact'), path: '/contact' },
        { name: this.$t('nav.about'), path: '/about' }
      ];
    }
  }
};
</script>

<style lang="stylus" scoped>
.download-page {
  min-height: 100vh;
  background: #f8f9fa;
}

/* Breadcrumb */
.breadcrumb-bar {
  background: #f0f0f0;
  border-bottom: 1px solid #e0e0e0;
}

.breadcrumb-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 24px;
  font-size: 13px;
  color: #666;

  a {
    color: #666;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #0066cc;
    }
  }
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-current {
  color: #333;
  font-weight: 500;
}

/* Main Layout */
.download-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 24px;
  display: flex;
  gap: 32px;
}

.download-main {
  flex: 1;
  min-width: 0;
}

.page-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin: 0 0 28px 0;
  padding-bottom: 16px;
  border-bottom: 2px solid #0066cc;
  display: inline-block;
}

/* Download List */
.download-list {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  margin-bottom: 32px;
}

.download-item {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #fafbfc;
  }
}

.download-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 16px;
  overflow: hidden;

  img {
    width: 36px;
    height: 36px;
    object-fit: contain;
  }
}

.download-info {
  flex: 1;
  min-width: 0;
}

.download-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
}

.download-platform {
  font-size: 13px;
  color: #999;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #0066cc;
  color: #fff;
  text-decoration: none;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background: #0052a3;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 102, 204, 0.3);
  }
}

.download-arrow {
  transition: transform 0.3s ease;
}

.download-btn:hover .download-arrow {
  transform: translateY(2px);
}

/* Agreement */
.download-agreement {
  text-align: center;
  margin-bottom: 32px;

  p {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  .agreement-link {
    color: #0066cc;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;

    &:hover {
      color: #0052a3;
      text-decoration: underline;
    }
  }
}

/* QR Section */
.qr-section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  padding: 28px;
}

.qr-title {
  font-size: 20px;
  font-weight: 600;
  color: #0066cc;
  margin: 0 0 20px 0;
}

.qr-content {
  display: flex;
  align-items: center;
  gap: 24px;
}

.qr-image-wrapper {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-desc {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* Sidebar */
.download-sidebar {
  width: 320px;
  flex-shrink: 0;
}

.sidebar-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  padding: 24px;
  margin-bottom: 20px;
}

.sidebar-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #0066cc;
}

.sidebar-links {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: #555;
    text-decoration: none;
    font-size: 14px;
    transition: color 0.3s ease;
    display: block;
    padding: 4px 0;

    &:hover {
      color: #0066cc;
    }
  }
}

.contact-card {
  .contact-info {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    color: #555;

    svg {
      flex-shrink: 0;
    }
  }
}

/* Responsive */
@media (max-width: 900px) {
  .download-container {
    flex-direction: column;
  }

  .download-sidebar {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .download-item {
    flex-wrap: wrap;
    gap: 12px;
  }

  .download-btn {
    width: 100%;
    justify-content: center;
  }

  .qr-content {
    flex-direction: column;
    text-align: center;
  }

  .page-title {
    font-size: 22px;
  }
}
</style>
